export class ActivityReservationLog {
  constructor (params = {}) {
    this.id = params.id
    this.created = new Date(params.created)
    this.previous = params.attributes.previous ? JSON.parse(params.attributes.previous) : null
    this.current = params.attributes.current ? JSON.parse(params.attributes.current) : null
    this.initiator = params.attributes.initiator ? params.attributes.initiator : null
  }
}
